//Return array for sales user menu
export const sales_menu = () => {
  return [{
      show: true,
      name: "Campaigns",
      link: "/tp/campaign",
      subMunu: [{
        link: "/tp/viewcampaign"
      }, ],
      white_image: "../../assets/images/campaingns.png",
      blue_image: "../../assets/images/campaingns_sl.png"
    },
    {
      show: true,
      name: "Incentive Details",
      link: "/tp/incentivedetails",
      subMunu: [{
        link: "/tp/incentivedetails"
      }, ],
      white_image: "../../assets/images/icon-document-white.png",
      blue_image: "../../assets/images/icon-document-blue.png"
    },
    {
      show: true,
      name: "Invoice Generation",
      link: "/tp/invoicedetails",
      subMunu: [{
        link: "/tp/invoicedetails"
      }, ],
      white_image: "../../assets/images/icon-document-white.png",
      blue_image: "../../assets/images/icon-document-blue.png"
    },
    {
      show: true,
      name: "Payout Details",
      link: "/tp/payouts",
      subMunu: [{
        link: "/tp/payouts"
      }, ],
      white_image: "../../assets/images/icon-document-white.png",
      blue_image: "../../assets/images/icon-document-blue.png"
    },
    {
      show: true,
      name: "KYC",
      link: "/tp/EditKycDetails",
      subMunu: [{
        link: "/tp/EditKycDetails"
      }, ],
      white_image: "../../assets/images/icon-document-white.png",
      blue_image: "../../assets/images/icon-document-blue.png"
    },
    {
      show: true,
      name: "Incentive T & C",
      link: "/tp/terms",
      subMunu: [{
        link: "/tp/terms"
      }, ],
      white_image: "../../assets/images/icon-document-white.png",
      blue_image: "../../assets/images/icon-document-blue.png"
    }
    ,
    {
      show: true,
      name: "Contact List",
      link: "/tp/contact",
      subMunu: [{
        link: "/tp/contact"
      }, ],
      white_image: "../../assets/images/contact_list-white.svg",
      blue_image: "../../assets/images/contact_list.svg"
    }
    ,
    {
      show: true,
      name: "Coupons",
      link: "/tp/coupons",
      subMunu: [{
        link: "/tp/coupons"
      }, ],
      white_image: "../../assets/images/manage_coupons-white.svg",
      blue_image: "../../assets/images/manage_coupons.svg"
    },
    {
      show: true,
      name: "Non FCT Codes",
      link: "/tp/nonfctcodes",
      subMunu: [{
        link: "/tp/nonfctcodes"
      }, ],
      white_image: "../../assets/images/manage_coupons-white.svg",
      blue_image: "../../assets/images/manage_coupons.svg"
    }
  ];
};


// WEBPACK FOOTER //
// ./web/menu/salesUser_menu_option.js